import React, { useState } from 'react';
import { Form } from 'antd';
import { useNavigate } from 'react-router-dom';

import ForgotPasswordComponent from "../../components/forgotPassword";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { forgotPasswordApi } from "../../services/auth.service"

interface ForgotPasswordContainerInterface {

}

const ForgotPasswordContainer: React.FC<ForgotPasswordContainerInterface> = () => {
  const dispatch = useAppDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate()

  const handleSubmission = (values?: any) => {
    setSubmitting(true)
    dispatch(forgotPasswordApi({
      data: values,
      finalCallback: () => {
        setSubmitting(false)
      },
      successCallback: () => {
        form.resetFields()
      }
    }))
  }

  const handleBackButton = () => {
    navigate(-1)
  }

  return (
    <ForgotPasswordComponent
      handleSubmission={handleSubmission}
      submitting={submitting}
      form={form}
      handleBackButton={handleBackButton}
    />
  )
}

export default ForgotPasswordContainer;
